import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScriptLoaderService
{
    loadButtonScript()
    {
        const isLocal: boolean =
            location.hostname === "localhost" || location.hostname.endsWith(".local") || location.hostname.startsWith("local.");

        const script = document.createElement('script');
        script.src = isLocal ? 'https://local.urlo.site/button.js' : 'https://urlo.site/button.js';
        script.setAttribute('data-site', isLocal ? '00000000-0000-0000-0000-000000000001' : '00000000-0000-0000-0000-000000000002');
        script.async = true;
        document.body.appendChild(script);
    }
}
